//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IDcard from "@/components/input/IDcard.vue";
import inputName from "@/components/input/inputName.vue";
import inputPhone from "@/components/input/inputPhone.vue";
import { codeReg } from "@/utils/regular.js";
import { store, mutations } from "@/observable/store";
import { Login, CacheModule, GetAge } from "@/utils/commonUtils";
import { FactoryUtils } from "@/utils/FactoryUtils";
// import  Social  from "@/components/layer/social" // 社保说明、
import { passport, loginMobile } from "@/model/api/loginService.js";
import InstructionProtocol from "@/components/instructionProtocol/index.vue";

export default {
	name: "identity",
	data() {
		return {
			templateFlag: "tk_acc",
			applicantNamePlaceholder: "请填写您的姓名",
			applicantNameVerify: false, // 被保人姓名
			applicantPhonePlaceholder: "请填写您的手机号码",
			applicantPhoneVerify: false,
			applicantIDcardPlaceholder: "请填写您的身份证号",
			applicantIDcardVerify: false, // 投保人错误提示
			applicantCode: "", //验证码
			count: "", // 倒计时
			showTime: true, //验证码时间切换
			timer: null,
			codeClickFlag: true, // 验证码防止点击
			Verification: false, // 验证码正则
			socialFlag: 2, // 有无社保 0 无 1 有
			socialList: [
				{ name: "有(含新农合)", key: 1 },
				{ name: "无", key: 0 },
			],
			security: 1,
			socialInfoData: {},
			treaty: {}, //协议
		};
	},
	components: {
		IDcard,
		inputName,
		inputPhone,
		InstructionProtocol,
		//   Social
	},
	props: ["identityTitle", "identityTitleDec"],
	computed: {
		uid() {
			return store.uid;
		},
		syToken() {
			return store.syToken;
		},
		loginPhone() {
			return store.phone;
		},
	},
	watch: {
		applicantCode(val) {
			this.Verification = false;
			// 判断手机号是否正确
			// 判断验证码是否位纯数字
			this.applicantCode = this.applicantCode.trim();
			let codeTest = codeReg.test(this.applicantCode);
			if (
				this.applicantPhoneInfo &&
				this.applicantPhoneInfo.phoneFlag &&
				val.length > 5 &&
				codeTest
			) {
				this.login();
			}
		},
		loginPhone(val) {
			this.bus.$emit("phoneInputFlag", val);
		},
	},
	created() {
		this.templateFlag = this.$route.query.templateFlag;
		//  静态文案
		// FactoryUtils.fromInfo().then(res =>{
		//     this.fromInfo = res;
		//     this.socialInfoData = res.tab.social.socialInfo
		// })
		FactoryUtils.fromInfo().then((res) => {
			this.fromInfo = res;
			this.treaty = res.treaty;
		});
	},
	methods: {
		creadInfo() {
			this.STATISTICS("click", "sybao_ins_proinfo_pay_click");
			// let top = document.getElementById('infoId').offsetTop
			// setTimeout(function(){
			//     scrollTo(0,top-40)
			// },100)
			if (
				!this.applicantNameInfo ||
				(this.applicantNameInfo && !this.applicantNameInfo.nameFlag)
			) {
				this.$toast("请填写正确的姓名");
				this.applicantNameVerify = true;
				return;
			}

			if (
				!this.applicantIDcardInfo ||
				(this.applicantIDcardInfo && !this.applicantIDcardInfo.idCardFlag)
			) {
				this.$toast("请填写正确的身份证号");
				this.applicantIDcardVerify = true;
				return;
			}
			// let age = GetAge(this.applicantIDcardInfo.idcard)
			// if(age > 60 || age < 18){
			//     this.$toast("本产品限制18-60周岁人群使用");
			//     return;
			// }
			if (
				!this.applicantPhoneInfo ||
				(this.applicantPhoneInfo && !this.applicantPhoneInfo.phoneFlag)
			) {
				this.$toast("请填写您的手机号码");
				this.applicantPhoneVerify = true;
				return;
			}
			if (!this.syToken || this.syToken == 0) {
				this.applicantCode = this.applicantCode.trim();
				let codeFlag = codeReg.test(this.applicantCode);
				if (!codeFlag) {
					this.$toast("请填写验证码");
					this.Verification = true;
					return;
				}
			}
			// if(this.socialFlag == 2){
			//         this.$toast("请选择有无社保");
			//         return;
			// }
			if (!this.$refs.instructionProtocol.selectFlag) {
				this.$toast("请认真阅读并勾选相关条款内容");
				return;
			}
			// 提交
			const parme = {
				name: this.applicantNameInfo.name, //姓名
				idcard: this.applicantIDcardInfo.idcard, //身份证号码
				phone: this.applicantPhoneInfo.phone,
			};
			this.$emit("identityInfo", parme);
		},
		socialClick(e) {
			if (e) {
				// 0 无社保
				this.STATISTICS("click", "sybao_ins_proinfo_amrr_click");
			} else {
				this.STATISTICS("click", "sybao_ins_proinfo_social_insurance_click");
			}
			this.socialFlag = e;
			this.security = this.socialList[e].key;
		},
		onBlur(data) {
			// 统计
			if (!data.inputText) {
				return false;
			}
			const buriedList = new Map()
				.set(
					"Idcard",
					this.STATISTICS_CONFIG.insur_proinfo_insuredidentity_click
				)
				.set(
					"inputName",
					this.STATISTICS_CONFIG.insur_proinfo_insuredname_click
				)
				.set("inputPhone", this.STATISTICS_CONFIG.insur_proinfo_phone_click);
			const buriedName = buriedList.get(data.message);
			buriedName();
		},
		codeBlur() {
			if (this.applicantCode) {
				this.STATISTICS_CONFIG.insur_proinfo_code_click();
			}
		},
		applicantNameEmit(msg) {
			this.applicantNameVerify = false;
			this.applicantNameInfo = msg;
		},
		applicantIDcardEmit(msg) {
			//投保人身份证号
			this.applicantIDcardVerify = false;
			this.applicantIDcardInfo = msg;
		},
		applicantPhoneEmit(msg) {
			this.applicantPhoneVerify = false;
			this.applicantPhoneInfo = msg;
		},
		treatyClick(item) {
			//协议跳转
			// 统计
			this.STATISTICS_CONFIG.insur_proinfo_clause_click();
			setTimeout(() => {
				this.$refs.InstructionRef.showToast(item.flag, item.name);
			}, 0);
		},
		getCodeTime() {
			const TIME_COUNT = 60;
			if (!this.timer) {
				this.count = TIME_COUNT;
				this.showTime = false;
				this.timer = setInterval(() => {
					if (this.count > 0 && this.count <= TIME_COUNT) {
						this.count--;
					} else {
						this.showTime = true;
						clearInterval(this.timer);
						this.timer = null;
					}
				}, 1000);
			}
		},
		getCode() {
			this.STATISTICS_CONFIG.insur_proinfo_getcode_click();
			if (
				!this.applicantPhoneInfo ||
				(this.applicantPhoneInfo && !this.applicantPhoneInfo.phoneFlag)
			) {
				this.$toast("请填写您的手机号码");
				// this.applicantPhoneVerify = true;
				this.applicantPhoneVerify = true;
				return;
			}
			if (this.codeClickFlag) {
				this.codeClickFlag = false;
				Login.getlogin()
					.then((data) => {
						this.getCodeTime();
						if (data && data.pass) {
							let parme = {
								phone: this.applicantPhoneInfo.phone,
								country_code: "86",
								// challenge:data.challenge,
								// sense_id:"39972a813f8696146efb3f2261cedfa1"
							};
							passport(parme)
								.then((data) => {})
								.catch((err) => {
									this.$toast(err.message);
								});
						}
					})
					.catch((err) => {
						this.$toast(err.message);
					})
					.finally(() => {
						this.codeClickFlag = true;
					});
			}
		},
		login() {
			let codeData = {
				phone: this.applicantPhoneInfo.phone,
				country_code: "86",
				code: this.applicantCode,
				sys: "15",
			};
			loginMobile(codeData)
				.then((data) => {
					this.getCodeFlag = true;
					mutations.getsyToken(data.token);
					mutations.getUid(data.uid);
					let userInfo = {
						login_token: data.token,
						login_uid: data.uid,
						login_phone: data.phone,
						login_insure_uid: data.insure_uid,
					};
					CacheModule.set("userInfo", userInfo);
				})
				.catch((err) => {
					if ((err.code = 1001)) {
						this.Verification = true;
						this.$toast(err.message);
					}
					this.getCodeFlag = false;
				});
		},
	},
};
